import React from "react";
import SupportHero from "../components/pagesComponents/supportPageComponents/SupportHero"
import ContactUs from "../components/pagesComponents/supportPageComponents/ContactUs";
import FAQ from "../components/pagesComponents/supportPageComponents/FAQ"

const Support: React.FC = () => {
  return (
   <>
   <SupportHero />
   <ContactUs />
   <FAQ />
   </>
  );
};

export default Support;
